import { Injectable } from "@angular/core";
import { CreateDataUpdateInput, DataUpdate, DataUpdateBulkReplaceGQL,DataUpdateAddProductGQL, DataUpdateAddProductsGQL, DataUpdateCreateGQL, DataUpdateRemoveGQL, DataUpdateRemoveProductGQL, DataUpdateRemoveProductsGQL, DataUpdatesGQL, DataUpdateUpdateGQL, UpdateDataUpdateInput } from "../graphql/generated/graphql";
import { map } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class DataUpdateService {
  constructor(
    private dataUpdatesGQL: DataUpdatesGQL,
    private dataUpdateBulkReplaceGQL: DataUpdateBulkReplaceGQL,
    private dataUpdateCreateGQL: DataUpdateCreateGQL,
    private dataUpdateUpdateGQL: DataUpdateUpdateGQL,
    private dataUpdateRemoveGQL: DataUpdateRemoveGQL,
    private dataUpdateAddProductGQL: DataUpdateAddProductGQL,
    private dataUpdateAddProductsGQL: DataUpdateAddProductsGQL,
    private dataUpdateRemoveProductGQL: DataUpdateRemoveProductGQL,
    private dataUpdateRemoveProductsGQL: DataUpdateRemoveProductsGQL,
  ) {}

  getDataUpdates() {
    return this.dataUpdatesGQL
      .fetch()
      .pipe(map((response) => response.data.dataUpdates as DataUpdate[]));
  }

  bulkReplaceDataUpdates(dataUpdateBulkReplaceInput: CreateDataUpdateInput[]) {
    return this.dataUpdateBulkReplaceGQL
      .mutate({ dataUpdateBulkReplaceInput })
      .pipe(map((result) => result.data?.dataUpdateBulkReplace as DataUpdate[]));
  }

  createDataUpdate(dataUpdateCreateInput: CreateDataUpdateInput) {
    return this.dataUpdateCreateGQL
      .mutate({ dataUpdateCreateInput })
      .pipe(map((result) => result.data?.dataUpdateCreate as DataUpdate));
  }

  updateDataUpdate(dataUpdateUpdateInput: UpdateDataUpdateInput) {
    return this.dataUpdateUpdateGQL
      .mutate({ dataUpdateUpdateInput })
      .pipe(map((result) => result.data?.dataUpdateUpdate as DataUpdate));
  }

  removeDataUpdate(dataUpdateRemoveId: number) {
    return this.dataUpdateRemoveGQL
      .mutate({ dataUpdateRemoveId })
      .pipe(map((result) => result.data?.dataUpdateRemove as DataUpdate));
  }

  addProductToDataUpdate(dataUpdateId: number, productId: number) {
    return this.dataUpdateAddProductGQL
      .mutate({
        dataUpdateId,
        productId,
      })
      .pipe(map((result) => result.data?.dataUpdateAddProduct as DataUpdate));
  }

  addProductsToDataUpdate(dataUpdateId: number, productIds: number[]) {
    return this.dataUpdateAddProductsGQL
      .mutate({
        dataUpdateId,
        productIds,
      })
      .pipe(map((result) => result.data?.dataUpdateAddProducts as DataUpdate));
  }

  removeProductFromDataUpdate(dataUpdateId: number, productId: number) {
    return this.dataUpdateRemoveProductGQL
      .mutate({
        dataUpdateId,
        productId,
      })
      .pipe(map((result) => result.data?.dataUpdateRemoveProduct as DataUpdate));
  }

  removeProductsFromDataUpdate(dataUpdateId: number, productIds: number[]) {
    return this.dataUpdateRemoveProductsGQL
      .mutate({
        dataUpdateId,
        productIds,
      })
      .pipe(map((result) => result.data?.dataUpdateRemoveProducts as DataUpdate));
  }
}